export const ReadLoyaltyBenefitsCardProductVx = 'ReadLoyaltyBenefitsCardProduct.v1';
